// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"restaurantSelect_wrapper__1ghmO"};